// list of status phase 2
export const projectStatusList = new Map([
  ["Execució", "Execució"], // MA is a intermediate state between 'MV' and 'Execució'
  ["MA", "Execució"], // MA is a intermediate state between 'MV' and 'Execució'
  ["MC", "Modificació en curs"],
  ["MP", "Modificació presentada"],
  ["MR", "Modificació retornada"],
  ["MV", "Modificació validada"],
]);

export const statesSecondPhaseAndJustificationList = new Map([
  ["Execució", "Execució"], // MA is a intermediate state between 'MV' and 'Execució'
  ["MA", "Execució"], // MA is a intermediate state between 'MV' and 'Execució'
  ["MC", "Modificació en curs"],
  ["MP", "Modificació presentada"],
  ["MR", "Modificació retornada"],
  ["MV", "Modificació validada"],
  ["Justificació en curs", "Justificació en curs"],
  ["Justificat", "Justificat"],
  ["Impacte", "Impacte"],
  ["Tancat", "Tancat"],
]);

export const projectStatusJustificationList = new Map([
  ["Justificació en curs", "Justificació en curs"],
  ["Justificat", "Justificat"],
  ["Impacte", "Impacte"],
  ["Tancat", "Tancat"],
]);

export const projectStatusJustificat = new Map([
  ["Justificat", "Justificat"],
  ["Impacte", "Impacte"],
  ["Tancat", "Tancat"],
]);

export const projectStatusImpacte = new Map([
  ["Impacte", "Impacte"],
  ["Tancat", "Tancat"],
]);

export const projectsStatusHigherThanExecucioList = new Map([
  ["Justificació en curs", "Justificació en curs"],
  ["Justificat", "Justificat"],
  ["Finalitzat", "Finalitzat"],
]);

// list of abbreviationStatus in projectStatusListReverse
export const projectStatusListReverse = new Map([
  ["Modificació en curs", "MC"],
  ["Modificació presentada", "MP"],
  ["Modificació retornada", "MR"],
  ["Modificació validada", "MV"],
]);

export const arrayStatesLabelNewProject = [
  "inicial",
  "presentat",
  "retornat",
  "validat",
];

// get the status (label) of a project
export const getLabelStatusProject = (key) => {
  return projectStatusList.get(key);
};

export const getLabelStatusProjectSecondPhaseAndJustification = (key) => {
  return statesSecondPhaseAndJustificationList.get(key);
};

// get the value (Abbreviation status project) of projectStatusListReverse
export const getAbbreviationStatusProject = (key) => {
  return projectStatusListReverse.get(key);
};

// search a status project in map of projectStatusList
export const searchStatus = (key) => {
  return projectStatusList.has(key) ? true : false;
};

export const searchStatusJustification = (key) => {
  return projectStatusJustificationList.has(key) ? true : false;
};

export const searchStatusProjectStatusJustificat = (key) => {
  return projectStatusJustificat.has(key) ? true : false;
};

export const searchStatusProjectStatusImpacte = (key) => {
  return projectStatusImpacte.has(key) ? true : false;
};

export const searchStatusHigherThanExecucio = (key) => {
  return projectsStatusHigherThanExecucioList.has(key) ? true : false;
};

export const searchStSecondPhaseOrJustification = (key) => {
  return statesSecondPhaseAndJustificationList.has(key) ? true : false;
};

//  search if the key is in map projectStatusListReverse
export const searchStatusReverse = (key) => {
  return projectStatusListReverse.has(key) ? true : false;
};
